import script from "./ContentModerationSet.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentModerationSet.vue?vue&type=script&setup=true&lang=js"

import "./ContentModerationSet.vue?vue&type=style&index=0&id=0076bf51&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0076bf51"]])

export default __exports__